import {getInductPackageMetrics} from "../resources/InductResource";
import {StowPackageMetric} from "../enums";
import {CYCLE, CYCLE_ID} from "../constants";
import {getStowPackageMetrics} from "../resources/StowResource";
import {getAPIGatewayDataFromParent} from "../handler/ParentDataHandler";
import {getAPIGatewayPostRequest, getStowBufferTableData} from "../resources/StowBufferResource";

export const INDUCT_CALL_SUCCESS = "INDUCT_CALL_SUCCESS";
export const INDUCT_CALL_FAILURE = "INDUCT_CALL_FAILURE";
export const INDUCT_CALL_BEGIN = 'INDUCT_CALL_BEGIN'
export const MACHINE_STATUS_CALL_SUCCESS = "MACHINE_STATUS_CALL_SUCCESS";
export const MACHINE_STATUS_CALL_FAILURE = "MACHINE_STATUS_CALL_FAILURE";
export const MACHINE_STATUS_CALL_BEGIN = 'MACHINE_STATUS_CALL_BEGIN'
export const BAY_TABLE_DATA_CALL_SUCCESS = "BAY_TABLE_DATA_CALL_SUCCESS";
export const BAY_TABLE_DATA_CALL_FAILURE = "BAY_TABLE_DATA_CALL_FAILURE";
export const BAY_TABLE_DATA_CALL_BEGIN = 'BAY_TABLE_DATA_CALL_BEGIN';
export const BAY_TABLE_DATA_CLEAR = 'BAY_TABLE_DATA_CLEAR';
export const MACHINE_TABLE_DATA_CALL_BEGIN = "MACHINE_TABLE_DATA_CALL_BEGIN"
export const MACHINE_TABLE_DATA_CALL_SUCCESS = "MACHINE_TABLE_DATA_CALL_SUCCESS";
export const MACHINE_TABLE_DATA_CALL_FAILURE = "MACHINE_TABLE_DATA_CALL_FAILURE";
export const PLANNED_COUNT_CALL_BEGIN = "PLANNED_COUNT_CALL_BEGIN"
export const PLANNED_COUNT_CALL_SUCCESS = "PLANNED_COUNT_CALL_SUCCESS";
export const PLANNED_COUNT_CALL_FAILURE = "PLANNED_COUNT_CALL_FAILURE";

const plannedCountDataCallBegin = () => ({
    type: PLANNED_COUNT_CALL_BEGIN,
});

const plannedCountDataCallSuccess = (stowPackageMetricsMap) => ({
    type: PLANNED_COUNT_CALL_SUCCESS,
    stowPackageMetricsMap
});

const plannedCountDataCallFailure = () => ({
    type: PLANNED_COUNT_CALL_FAILURE,
});

const machineTableDataCallBegin = () => ({
    type: MACHINE_TABLE_DATA_CALL_BEGIN,
});

export const machineTableDataCallSuccess = (machineList) => ({
    type: MACHINE_TABLE_DATA_CALL_SUCCESS,
    machineList,
});

const machineTableDataCallFailure = () => ({
    type: MACHINE_TABLE_DATA_CALL_FAILURE,
});

const inductCallSuccess = (inductCount) => ({
    type: INDUCT_CALL_SUCCESS,
    inductCount,
});

const inductCallBegin = () => ({
    type: INDUCT_CALL_BEGIN,
});

const inductCallFailure = () => ({
    type: INDUCT_CALL_FAILURE,
});

const machineStatusCallSuccess = (machineStatusList) => ({
    type: MACHINE_STATUS_CALL_SUCCESS,
    machineStatusList,
});

const machineStatusCallBegin = () => ({
    type: MACHINE_STATUS_CALL_BEGIN,
});

const machineStatusCallFailure = () => ({
    type: MACHINE_STATUS_CALL_FAILURE,
});

export const bayTableDataCallSuccess = (bayList) => ({
    type: BAY_TABLE_DATA_CALL_SUCCESS,
    bayList,
});

const bayTableDataCallBegin = () => ({
    type: BAY_TABLE_DATA_CALL_BEGIN,
});

export const bayTableDataClear = () => ({
    type: BAY_TABLE_DATA_CLEAR,
});

const bayTableDataCallFailure = () => ({
    type: BAY_TABLE_DATA_CALL_FAILURE,
});

function addStatusToMachineList(machineList, machineStatusList) {
    const machineStatusMap = {}
    machineStatusList && machineStatusList.data.adtaStatusList.forEach(machine => {
        machineStatusMap[machine.mac] = machine.status
    })

    return machineList.map(machine => {
        return {
            ...machine,
            status: machineStatusMap[machine.macAddress]
        }
    })
}

function addPlannedVolumeToBayTable(bayList, plannedVolumeList) {
    const plannedVolumeMap = {}
    for (const [key, value] of Object.entries(plannedVolumeList)) {
        plannedVolumeMap[key] = value.plannedPackages
    }

    return bayList.map(bayListItem => {
        let plannedVolumeSum = 0;
        bayListItem.name.split(" ").forEach((bay) => {
            const bayName = bay[0] + bay.slice(2);
            plannedVolumeSum += parseInt(plannedVolumeMap[bayName], 10)
        })

        if(!plannedVolumeSum && plannedVolumeSum !== 0) {
            plannedVolumeSum = "-"
        }

        return {
            ...bayListItem,
            plannedVolumeSum: plannedVolumeSum
        }
    })
}

export function getInductCount(cycles, nodeId) {
    let filterMap = {
        'Cycle': [cycles]
    }

    const request = {
        nodeId,
        groupBy: 'Node',
        filters: filterMap,
        metricList: ["PLANNED_CURRENT_CYCLE_INDUCTED", "UNPLANNED_CURRENT_CYCLE_INDUCTED"]
    }

    return async dispatch => {
        dispatch(inductCallBegin())
        try {
            const inductPackageMetricsMap = await getInductPackageMetrics(request);
            const inductValue = inductPackageMetricsMap[nodeId].plannedInducted + inductPackageMetricsMap[nodeId].unplannedInducted
            dispatch(inductCallSuccess(inductValue))
        } catch (error) {
            dispatch(inductCallFailure())
        }
    }
}

export function getMachineTableData(nodeId, cycles, groupBy) {
    const request = {
        filters: {
            NODE: [nodeId],
        },
        fieldsRequired: ["NAME", "STATUS", "PERFORMANCE", "LOCATION"],
        tabView: "STOW_BUFFERED",
    };

    if (groupBy) {
        request['groupBy'] = groupBy
    }
    if (cycles.length) {
        request.filters[CYCLE] = [cycles];
    }

    return async dispatch => {
        try {
            dispatch(machineTableDataCallBegin());
            const machineList = await getStowBufferTableData(request);
            if (machineList) {
                dispatch(machineTableDataCallSuccess(machineList));
            } else {
                dispatch(machineTableDataCallFailure());
            }
        } catch (error) {
            dispatch(machineTableDataCallFailure());
        }
    }
}

export function getBayTableData(nodeId, cycles, groupBy, machineName, plannedVolumeList) {
    const request = {
        filters: {
            NODE: [nodeId],
        },
        fieldsRequired: ["NAME", "STATUS", "PERFORMANCE", "LOCATION"],
        tabView: "STOW_BUFFERED"
    };

    if (groupBy) {
        request['groupBy'] = groupBy
    }
    if (machineName) {
        request.filters['ASSOCIATE'] = [machineName]
    }
    if (cycles.length) {
        request.filters[CYCLE] = [cycles];
    }

    return async dispatch => {
        try {
            dispatch(bayTableDataCallBegin());
            const bayList = await getStowBufferTableData(request);
            const mappedBayList = addPlannedVolumeToBayTable(bayList, plannedVolumeList)

            if (mappedBayList) {
                dispatch(bayTableDataCallSuccess(mappedBayList))
            } else {
                dispatch(bayTableDataCallFailure());
            }
        } catch (error) {
            dispatch(bayTableDataCallFailure());
        }
    }
}

export function getMachineStatus(nodeId, machineList) {
    const macAddressList = machineList.map(machine => machine.macAddress);

    const request = {
        nodeId,
        macAddressList,
    };

    return async dispatch => {
        try {
            dispatch(machineStatusCallBegin());
            const args = getAPIGatewayPostRequest(request, "ndms/getADTAStatus", "deviceManagement");
            const machineStatusList = await getAPIGatewayDataFromParent(args);
            const mappedMachineList = addStatusToMachineList(machineList, machineStatusList)

            if (machineStatusList) {
                dispatch(machineTableDataCallSuccess(mappedMachineList));
                dispatch(machineStatusCallSuccess(machineStatusList));
            } else {
                dispatch(machineStatusCallFailure());
            }
        } catch (error) {
            dispatch(machineStatusCallFailure());
        }
    }
}

export function getPlannedCount(nodeId, cycles, cycleIds) {
    const request = {
        groupBy: 'AISLE',
        filters: {
            NODE: [nodeId],
            DRS: ['FALSE']
        },
        metrics: [StowPackageMetric.PLANNED_COUNT]
    }

    if (cycles.length) {
        request.filters[CYCLE] = [cycles];
    }
    if (cycleIds.length) {
        request.filters[CYCLE_ID] = [cycleIds];
    }

    return async (dispatch) => {
        try {
            dispatch(plannedCountDataCallBegin());
            const stowPackageMetricsMap = await getStowPackageMetrics(request);
            if (stowPackageMetricsMap) {
                dispatch(plannedCountDataCallSuccess(stowPackageMetricsMap));
            } else {
                dispatch(plannedCountDataCallFailure());
            }
        } catch (error) {
            dispatch(plannedCountDataCallFailure());
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/StowBufferAction.js